import React from 'react';
import { AssetModel } from './assets-models';
import { Icon } from '@hai/ui-react';

interface RecordingsBreadcrumbProps {
  item?: AssetModel;
  onClickBack: (evt: React.MouseEvent<HTMLElement>) => void;
}

export const RecordingsBreadcrumb = ({ item, onClickBack }: RecordingsBreadcrumbProps): JSX.Element | null => {
  if (!item) {
    return null;
  }

  const breadcrumbItems: AssetModel[] = [];
  let current: AssetModel | undefined = item;

  while (current) {
    // unshift inserts at index 0 so breadcrumbs render from root to leaf.
    breadcrumbItems.unshift(current);
    current = current.parent;
  }

  const parentItem = breadcrumbItems.length > 1 ? breadcrumbItems[breadcrumbItems.length - 2] : undefined;
  const backHref = parentItem ? `/media/recordings/${encodeURIComponent(parentItem.id)}` : '/media/recordings';

  return (
    <div className="mk-breadcrum">
      <a href={backHref} onClick={onClickBack}>
        <Icon iconname="ArrowMenuBack" />
        {'\u00A0'}Back
      </a>
      {breadcrumbItems.map((crumb) => (
        <React.Fragment key={crumb.id}>
          <span>{'\u00A0/\u00A0'}</span>
          <span>{crumb.name}</span>
        </React.Fragment>
      ))}
    </div>
  );
};
